<template>
  <section class="main-care">
    <su-licenses-modal
      v-if="showLicensesModal"
      @close="showLicensesModal = false"
    />

    <div class="main-care__items">
      <div class="main-care__block main-care__block-1">
        <h6 class="main-care__block_title">
          обучение без&nbsp;границ
        </h6>
        <p class="main-care__block_text">
          ученики подключаются к&nbsp;занятиям из&nbsp;любой точки мира
          и&nbsp;успешно совмещают учебу с&nbsp;творческой и&nbsp;спортивной карьерой
        </p>

        <div class="main-care__block_countries">
          <img
            src="/v2/school-university/reviews/rus.png"
            alt="Russia"
          >
          <img
            src="/v2/school-university/reviews/bra.png"
            alt="Brazil"
          >
          <img
            src="/v2/school-university/reviews/arg.png"
            alt="Argentina"
          >
          <img
            src="/v2/school-university/reviews/tur.png"
            alt="Turkey"
          >
          <img
            src="/v2/school-university/reviews/indo.png"
            alt="Indonesia"
          >
          <img
            src="/v2/school-university/reviews/indi.png"
            alt="India"
          >
          <img
            src="/v2/school-university/reviews/gb.png"
            alt="Great britain"
          >
          <img
            src="/v2/school-university/reviews/kaz.png"
            alt="Kazakhstan"
          >

          <span>и еще более +30&nbsp;стран</span>
        </div>
      </div>

      <div class="main-care__block main-care__block-2">
        <h6 class="main-care__block_title">
          преподаватели высокого уровня
        </h6>
        <p class="main-care__block_text">
          занятия проводят опытные педагоги, которые легко объясняют
          даже сложные темы и всегда готовы помочь ученикам
        </p>

        <ul>
          <li>прошли 3 ступени отбора, только 1 из 7 попадает к нам</li>
          <li>из топовых вузов: МГУ, ВШЭ, Бауманка, МПГУ и другие</li>
          <li>имеют стаж работы с детьми более 5 лет</li>
          <li>ежегодно сдают ЕГЭ&nbsp;на&nbsp;95+&nbsp;баллов</li>
        </ul>
      </div>

      <div class="main-care__block main-care__block-3">
        <h6 class="main-care__block_title">
          гос. лицензия и&nbsp;аккредитация
        </h6>
        <p class="main-care__block_text">
          благодаря этому мы <span>выдаем аттестаты самостоятельно</span>,
          а&nbsp;не&nbsp;через партнеров, как&nbsp;это&nbsp;делают&nbsp;другие школы
        </p>

        <button
          class="m-btn"
          @click="showLicensesModal = true"
        />
      </div>

      <div class="main-care__block main-care__block-4">
        <h6 class="main-care__block_title">
          персональная поддержка
        </h6>
        <p class="main-care__block_text">
          кураторы и наставники всегда готовы&nbsp;поддержать учеников
          в&nbsp;учебе&nbsp;и&nbsp;помочь им адаптироваться к&nbsp;дистанционному обучению.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import SuLicensesModal from '../school-university/SuLicensesModal.vue';

export default {
  name: 'SchoolNewChoose',
  components: { SuLicensesModal },
  data: () => ({
    showLicensesModal: false,
  }),
};
</script>

<style scoped lang="scss">

.main-care {
  .main-care__items {
    display: grid;
    grid-template-columns: repeat(2, calc(50% - 1.25rem / 2));
    gap: 1.25rem;

    @include media-down($size-tablet) {
      grid-template-columns: repeat(2, calc(50% - 0.4rem));
      grid-template-rows: calc(var(--scale) * 512) calc(var(--scale) * 512);
      gap: 0.8rem;
    }

    @include media-down($size-mobile) {
      grid-template-columns: 100%;
      grid-template-rows: repeat(4, 51.2rem);
    }
  }

  .main-care__block {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 2.5rem;
    position: relative;
    background-color: #FFFFFF;
    background-repeat: no-repeat;
    border-radius: 2.5rem;

    @include media-down($size-tablet) {
      padding: 1.6rem 1.4rem 1.6rem 1.6rem;
    }

    &_title {
      margin-bottom: 0.75rem;

      font-style: normal;
      font-weight: 500;
      font-size: 3rem;
      line-height: 110%;
      letter-spacing: -0.02em;
      color: #02120F;

      @include media-down($size-tablet) {
        margin-bottom: 0.8rem;
        font-size: 4rem;
        letter-spacing: -0.04em;
      }
    }

    &_text {
      font-style: normal;
      font-weight: 500;
      font-size: calc(var(--scale) * 26);
      line-height: 120%;
      color: #A7ABAC;

      @include media-down($size-tablet) {
        font-size: 1.8rem;
        line-height: 110%;
      }
    }

    &-1 {
      background-image: url("/v2/school-new/choose/world.webp");
      background-position: bottom center;
      background-size: 100% auto;

      @include media-down($size-tablet) {
        background-image: url("/v2/school-new/choose/world-tablet.webp");
      }

      .main-care__block_countries {
        margin-top: calc(var(--scale) * 20);
        display: flex;
        align-items: center;

        @include media-down($size-tablet) {
          margin-top: calc(var(--scale) * 16);
        }

        img {
          position: relative;
          width: calc(var(--scale) * 46);
          aspect-ratio: 1/1;

          border: 1px solid #ECEDF0;
          border-radius: calc(var(--scale) * 100);
          margin-right: calc(-1  * var(--scale) * 6);
          outline: calc(var(--scale) * 2) solid #ffffff;

          @include media-down($size-tablet) {
            width: calc(var(--scale) * 32);
          }

          &:nth-of-type(1) { z-index: 7; }
          &:nth-of-type(2) { z-index: 6; }
          &:nth-of-type(3) { z-index: 5; }
          &:nth-of-type(4) { z-index: 4; }
          &:nth-of-type(5) { z-index: 3; }
          &:nth-of-type(6) { z-index: 2; }
          &:nth-of-type(7) { z-index: 1; }
          &:nth-of-type(8) { z-index: 0; }
        }

        span {
          margin-left: calc(var(--scale) * 25);

          font-weight: 400;
          font-size: calc(var(--scale) * 20);
          line-height: 130%;
          color: #02120F;

          @include media-down($size-tablet) {
            margin-left: 1.4rem;
            font-weight: 500;
            font-size: 1.4rem;
            max-width: calc(var(--scale) * 96);
          }
        }
      }
    }

    &-2 {
      background-image: url("/v2/school-new/choose/teacher.webp");
      background-position: bottom right;
      background-size: auto calc(100% - var(--scale) * 40);

      @include media-down($size-tablet) {
        background-size: calc(var(--scale) * 190) auto;
      }

      @include media-down($size-mobile) {
        background-size: calc(var(--scale) * 175) auto;
        background-position: bottom calc(-1 * var(--scale) * 12) right;
      }

      .main-care__block_title,
      .main-care__block_text {
        max-width: calc(var(--scale) * 560);
      }

      ul {
        margin-top: auto;
        display: flex;
        flex-direction: column;
        gap: calc(var(--scale) * 8);

        @include media-down($size-tablet) {
          max-width: calc(var(--scale) * 244);
          margin-top: calc(var(--scale) * 20);
        }

        li {
          display: flex;
          align-items: center;
          gap: calc(var(--scale) * 12);

          font-weight: 400;
          font-size: calc(var(--scale) * 20);
          line-height: 130%;
          color: #02120F;

          @include media-down($size-tablet) {
            gap: calc(var(--scale) * 8);

            font-size: calc(var(--scale) * 16);
            letter-spacing: -0.02em;
            color: #02120F;
          }

          &:before {
            content: '';
            flex-shrink: 0;
            display: block;
            width: calc(var(--scale) * 12);
            height: calc(var(--scale) * 12);
            background-color: #FF5319;
            border-radius: 2px;
          }
        }
      }
    }

    &-3 {
      background-image: url("/v2/school-new/choose/license.webp");
      background-position: bottom right;
      background-size: auto 100%;

      @include media-down($size-tablet) {
        background-size: 100% auto;
        background-image: url("/v2/school-new/choose/license-tablet.webp");
      }

      .main-care__block_text {
        margin-bottom: auto;
        max-width: calc(var(--scale) * 525);

        span {
          color: #FF5319;
        }
      }

      button {
        width: 100%;
        height: calc(var(--scale) * 300);
        position: absolute;
        z-index: 2;
        left: 0;
        bottom: 0;
        cursor: pointer;
        outline: none;
      }
    }

    &-4 {
      margin-top: calc(-1 * var(--scale) * 227);

      background-image: url("/v2/main/care/tutors.webp");
      background-position: bottom;
      background-size: 100% auto;

      @include media-down($size-tablet) {
        margin-top: 0;
        background-image: url("/v2/main/care/tutors-mob.webp");
      }
    }

    &-2,
    &-3 {
      height: calc(var(--scale) * 493);

      @include media-down($size-tablet) {
        height: 100%;
      }
    }

    &-1,
    &-4 {
      height: calc(var(--scale) * 720);

      @include media-down($size-tablet) {
        height: 100%;
      }

      .main-care__block_text {
        max-width: calc(var(--scale) * 615);
      }
    }
  }
}

</style>
